import { autoinject } from "aurelia-framework";
import { Router, RouterConfiguration, activationStrategy } from "aurelia-router";
import { Colors } from "./colors";
import { I18N } from "aurelia-i18n";
import "materialize-css/dist/css/materialize.css";
import "@mdi/font/css/materialdesignicons.css";
//import "leaflet/dist/leaflet.css";
import { Subscription } from 'rxjs';
import { IState } from "../store/state";
import { getLocationHierarchy } from "../store/actions/location-actions";
import { HubManager } from '../services/hub-manager';
import { applicationLogger } from "../logging/logger";
import { localStorageMiddleware, logMiddleware, LogLevel, MiddlewarePlacement, rehydrateFromLocalStorage, Store } from 'aurelia-store';
const greenhouseStorageKey = "greenhouse-storage-key";


@autoinject
export class App {

	primaryColor: string;
	accentColor: string;
	errorColor: string;
	successColor: string;
	linkColor: string;
	router: Router;
	i18n: I18N;
	store: Store<IState>;
	hubManager : HubManager;
	loading: boolean = false;
	applicationState: IState;


	constructor(colors: Colors, i18n: I18N, store: Store<IState>, hubManager: HubManager) {
		this.primaryColor = colors.primaryColor;
		this.accentColor = colors.accentColor;
		this.errorColor = colors.errorColor;
		this.linkColor = colors.linkColor;
		this.successColor = colors.successColor;
		this.i18n = i18n;
		this.store = store;
		this.hubManager = hubManager;
		

		this.store.registerMiddleware(logMiddleware, MiddlewarePlacement.After, { logType: LogLevel.log });
		// LocalStorageMiddleware should be the last one in the chain.
		this.store.registerMiddleware(localStorageMiddleware, MiddlewarePlacement.After, { key: greenhouseStorageKey });
		this.store.registerAction('Rehydrate', rehydrateFromLocalStorage);
		this.store.dispatch(rehydrateFromLocalStorage, greenhouseStorageKey);
	}

	async bind(bindingContext: any, overrideContext: any) {
		applicationLogger.info("app.bind() called.");
		const this_ = this;
		setTimeout(async () => {
			this_.loading = true;
			await this_.store.dispatch(getLocationHierarchy);
			this_.hubManager.start();
			this_.loading = false;
		}, 100);
	}

	deactivate() {
		this.store.unregisterAction(rehydrateFromLocalStorage);
		this.store.unregisterMiddleware(localStorageMiddleware);
		this.store.unregisterMiddleware(logMiddleware);
	}

	configureRouter(config: RouterConfiguration, router: Router) {
		config.title = "Nursery Sentry";
		//router.baseUrl = "/app";
		//config.options.root = "/app";
		config.map([{
			route: ["", "warnings"],
			name: "warnings",
			settings: { icon: "warning", t: "warnings" },
			moduleId: "../pages/warnings/warnings",
			nav: true,
			title: "Warnings",
		}, {
				route: ["devices"],
				name: "devices",
				settings: { icon: "router", t: "devices"  },
				moduleId: "../pages/devices/devices",
				activationStrategy: activationStrategy.replace,
				nav: true,
				title: "Devices"
			}, {
				route: ["notification-rules"],
				name: "notification-rules",
				settings: { icon: "send", t: "notification-rules"  },
				moduleId: "../pages/notification-rules/notification-rules",
				nav: false,
				title: "Notification Rules"
			}, {
				route: ["notification-recipients"],
				name: "notification-recipients",
				settings: { icon: "send", t: "notification-recipients"  },
				moduleId: "../pages/notification-recipients/notification-recipients",
				nav: false,
				title: "Notification Recipients"
			}, {
				route: ["admin-dashboard"],
				name: "admin-dashboard",
				settings: { icon: "dashboard", t: "dashboard" },
				moduleId: "../pages/admin-dashboard/admin-dashboard",
				nav: false,
				title: "Admin Dashboard"
			}, {
				route: ["asset-tracking"],
				name: "asset-tracking",
				settings: { icon: "dashboard", t: "dashboard" },
			    moduleId: "../pages/asset-tracking/asset-tracking",
				nav: false,
				title: "Asset Tracking"
			}, {
				route: ["signal-mapping"],
				name: "signal-mapping",
				settings: { icon: "dashboard", t: "dashboard" },
				moduleId: "../pages/signal-mapping/signal-mapping",
				nav: false,
				title: "Signal Mapping"
			}
			, {
				route: ["structure-detail"],
				name: "structure-detail",
				settings: { icon: "dashboard", t: "dashboard" },
				moduleId: "../pages/structure-detail/structure-detail",
				nav: false,
				title: "Structure Detail"
			}
			]);
	}
}
